import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['step1', 'step2'];
  static values = {
    startOnConfirm: Boolean,
  };

  connect() {
    if (this.startOnConfirmValue) {
      this.showStep1();
    } else {
      this.showStep2();
    }
  }

  showStep1() {
    this.step1Target.classList.remove('hidden');
    this.step2Target.classList.add('hidden');
  }

  showStep2() {
    this.step2Target.classList.remove('hidden');
    this.step1Target.classList.add('hidden');
  }
}
